var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBullseye = function SvgBullseye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 420.2 419.7",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M214.9 251.4a33 33 0 0 1-46.6-46.6l.6-.6L277.7 95.4a153.7 153.7 0 1 0 46.7 46.6l-109 108.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M420.2 86.5h-87.5V0L282 50.7A194 194 0 0 0 194.8 30a194.8 194.8 0 1 0 194.8 194.8 194 194 0 0 0-20.5-87.2zM275.3 225a80.5 80.5 0 1 1-51.8-75.3l-54.6 54.7-.6.5a33 33 0 0 0 46.6 46.6l.6-.6 54.6-54.6a80.3 80.3 0 0 1 5.2 28.7zm-80.5 153.8a153.8 153.8 0 1 1 83-283.4l-26.3 26.3a117.8 117.8 0 1 0 46.6 46.6l26.2-26.2a153.8 153.8 0 0 1-129.5 236.6z"
  })));
};
export default SvgBullseye;